//
import * as React from 'react';

import Box from '@mui/material/Box';
import type { BoxProps } from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

export interface StdDialogProgressProps extends BoxProps {
  icon?: React.ElementType;
  label?: React.ReactNode;
}

const StdDialogProgress: React.FC<StdDialogProgressProps> = ({ icon, label, ...otherProps }) => {
  const theme = useTheme();

  return (
    <Box display='flex' flexDirection='column' height='0px' style={{ transform: 'translate(0, 48px)' }} {...otherProps}>
      <CircularProgress size={130} style={{ margin: 'auto' }} />
      {label && (
        <Box alignContent='center' alignSelf='center' color='#666666' display='flex' pt={3}>
          {icon && <Box component={icon} htmlColor={theme.palette.primary.main} style={{ marginRight: '12px' }} />}
          <Typography>{label}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default StdDialogProgress;
